import { Layer as LLayer } from 'leaflet';

/**
 * 图层基类
 * @interface
 */
export default class Layer extends LLayer {
    /**
     * 构造函数
     * @param {string} id 图层ID
     * @param {Object} options 可选项
     */
    constructor(id, options) {
        super(options);

        this.setOptions(options);

        this.id = id;
    }

    /**
     * 设置可选参数
     * @param  {object}    options 可选参数
     * @return {undefined}
     */
    setOptions(options) {
        this.options = Object.assign({}, this.options, options);
    }

    /**
     * 将图层添加到地图对象之前执行
     * 主要进行一些不依赖与地图对象的数据初始化和信息校验
     * @param {Object} map 地图对象
     */
    beforeAdd(map) {
        if (super.beforeAdd) {
            super.beforeAdd(map);
        }

        map._addZoomLimit(this);
    }

    /**
     * 将图层添加到地图对象上
     * @param {Object} map 地图对象
     */
    onAdd(map) {
        if (super.onAdd) {
            super.onAdd(map);
        }
    }

    /**
     * 将图层从地图对象上删除
     * @param {Object} map 地图对象
     */
    onRemove(map) {
        map._removeZoomLimit(this);
        if (super.onRemove) {
            super.onRemove(map);
        }
    }

    // @function toFront(el: HTMLElement)
    // Makes `el` the last child of its parent, so it renders in front of the other children.
    _toFront(el) {
        const parent = el.parentNode;
        if (parent && parent.lastChild !== el) {
            parent.appendChild(el);
        }
    }

    // @function toBack(el: HTMLElement)
    // Makes `el` the first child of its parent, so it renders behind the other children.
    _toBack(el) {
        const parent = el.parentNode;
        if (parent && parent.firstChild !== el) {
            parent.insertBefore(el, parent.firstChild);
        }
    }
}
